export const BUTTON_COLORS = {
  PRIMARY: "primary",
  ACCENT: "accent",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  SURFACE_INVERSE: "surfaceInverse",
  ON_SURFACE_INVERSE: "onSurfaceInverse",
} as const

const BUTTON_SIZES = {
  MEDIUM: "medium",
  LARGE: "large",
  SMALL: "small",
} as const

const BUTTON_TYPES = {
  FILLED: "filled",
  OUTLINE: "outline",
  TEXT: "text",
} as const

export type ButtonType = (typeof BUTTON_TYPES)[keyof typeof BUTTON_TYPES]
export type ButtonColor = (typeof BUTTON_COLORS)[keyof typeof BUTTON_COLORS]
export type ButtonSize = (typeof BUTTON_SIZES)[keyof typeof BUTTON_SIZES]

export { BUTTON_COLORS as buttonColors, BUTTON_SIZES as buttonSizes, BUTTON_TYPES as buttonTypes }
